import { useState } from 'react';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      return;
    }
    formData.delete('phone_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9m58cobdkpk99j7g6sg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络异常，请稍后重试');
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              有任何问题或建议？欢迎随时与我们联系
            </p>
          </div>

          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="bg-background-50 rounded-lg border border-secondary-200/70 p-6 md:p-8"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  姓名
                </label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-secondary-300 rounded-md focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  邮箱
                </label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-secondary-300 rounded-md focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入邮箱"
                />
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                主题
              </label>
              <select
                id="contact-subject"
                name="subject"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-100 border border-secondary-300 rounded-md focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors cursor-pointer"
                defaultValue=""
              >
                <option value="" disabled>请选择主题</option>
                <option value="资源反馈">资源反馈</option>
                <option value="播放问题">播放问题</option>
                <option value="内容建议">内容建议</option>
                <option value="合作咨询">合作咨询</option>
                <option value="其他问题">其他问题</option>
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容
              </label>
              <textarea
                id="contact-message"
                name="message"
                required
                maxLength={500}
                rows={5}
                className="w-full px-4 py-2.5 text-sm bg-background-100 border border-secondary-300 rounded-md focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                placeholder="请输入您的留言内容（不超过500字）"
              ></textarea>
              <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
            </div>

            <input
              name="phone_alt"
              type="text"
              className="honeypot-field"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            <button
              type="submit"
              className="w-full px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              提交留言
            </button>

            {status === 'success' && (
              <div className="mt-4 p-3 bg-accent-50 text-accent-700 text-sm rounded-md text-center">
                感谢您的留言，我们会尽快回复！
              </div>
            )}
            {status === 'error' && (
              <div className="mt-4 p-3 bg-primary-50 text-primary-700 text-sm rounded-md text-center">
                {errorMsg}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}